module.exports = __webpack_public_path__ + "img/loginBg.890d7d62.png";